import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading, KPITile } from "../components/Common";

export default function LibraryPage() {
  const [books, setBooks] = useState(null);
  useEffect(() => { api.libraryBooks().then(({ data }) => setBooks(data)); }, []);
  if (books === null) return <Loading />;
  const total = books.reduce((a, b) => a + b.copies_total, 0);
  const avail = books.reduce((a, b) => a + b.copies_available, 0);
  return (
    <div data-testid="library-page">
      <PageHeader kicker="Library" title="Highlands Library" subtitle="Catalog, availability and loans." />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <KPITile tone="dark" testId="lib-titles" label="Titles" value={books.length} />
        <KPITile testId="lib-copies" label="Total copies" value={total} />
        <KPITile testId="lib-avail" label="Available" value={avail} />
      </div>
      <Section>
        <DataTable
          columns={[
            { key: "title", label: "Title" },
            { key: "author", label: "Author" },
            { key: "category", label: "Category" },
            { key: "isbn", label: "ISBN", render: (r) => <span className="mono text-xs">{r.isbn}</span> },
            { key: "copies_available", label: "Available" },
          ]}
          rows={books}
        />
      </Section>
    </div>
  );
}
